<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.ssoActivityId]"
		[controlName]="ActivityCsvKeys.ssoActivityId"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.ssoActivityId]"
		[required]="form.get(ActivityCsvKeys.ssoActivityId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.ssoLessonId]"
		[controlName]="ActivityCsvKeys.ssoLessonId"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.ssoLessonId]"
		[required]="form.get(ActivityCsvKeys.ssoLessonId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.defaultLangId]"
		[controlName]="ActivityCsvKeys.defaultLangId"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.defaultLangId]"
		[required]="form.get(ActivityCsvKeys.defaultLangId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.displayOrder]"
		[controlName]="ActivityCsvKeys.displayOrder"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.displayOrder]"
		[required]="form.get(ActivityCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.isInstruction]"
		[controlName]="ActivityCsvKeys.isInstruction"
		[required]="form.get(ActivityCsvKeys.isInstruction)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enName]"
		[controlName]="ActivityCsvKeys.enName"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enName]"
		[required]="form.get(ActivityCsvKeys.enName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enImageUri]"
		[controlName]="ActivityCsvKeys.enImageUri"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enImageUri]"
		[required]="form.get(ActivityCsvKeys.enImageUri)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enDescriptionShort]"
		[controlName]="ActivityCsvKeys.enDescriptionShort"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enDescriptionShort]"
		[required]="form.get(ActivityCsvKeys.enDescriptionShort)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enDescriptionHtml]"
		[controlName]="ActivityCsvKeys.enDescriptionHtml"
		[placeholder]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.enDescriptionHtml]"
		[required]="form.get(ActivityCsvKeys.enDescriptionHtml)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="ACTIVITY_CSV_LABELS[ActivityCsvKeys.active]"
		[controlName]="ActivityCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
